<template>
    <div class='page' :page-name="name" :style="style">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'page',

    props: {
        height: {type: String, required: true},
        name: {type: String, required: true}
    },

    computed: {
        style(){
            return {height: this.height}
        }
    }
}
</script>

<style lang="scss" scoped>
    .page {}
</style>